import type { StoreApi, UseBoundStore } from 'zustand'
import { createStore, type StoreState } from './Store'
import type { AuthUser } from '../../server/lib/auth'

const defaults = {
  status: 'unknown' as 'unknown' | 'loading' | 'authenticated' | 'unauthenticated',
  user: null as AuthUser | null,
  error: null as string | null,
}

type AuthFields = typeof defaults
type AuthState = StoreState<AuthFields>

export const useAuthStore: UseBoundStore<StoreApi<AuthState>> = createStore(defaults)

export type { AuthState }
